import { render } from "./driver-page.vue?vue&type=template&id=6287d33a&scoped=true"
import script from "./driver-page.vue?vue&type=script&lang=js"
export * from "./driver-page.vue?vue&type=script&lang=js"

import "./driver-page.vue?vue&type=style&index=0&id=6287d33a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6287d33a"]])

export default __exports__